import type { ChangeEvent, FunctionComponent } from 'react';
import * as styles from './Checkbox.module.css';

interface CheckboxProps {
  id: number;
  label?: string;
  readonly?: boolean;
  checked?: boolean;
  onClick?: (newValue: boolean) => void;
  isMaximumReached: boolean;
}

const Checkbox: FunctionComponent<CheckboxProps> = ({
  id,
  label,
  readonly,
  checked,
  onClick,
  isMaximumReached,
}) => {
  const handleClickElement = (event: ChangeEvent<HTMLInputElement>) => {
    if (readonly) return;
    const newCheckedStatus = event.target.checked;
    onClick && onClick(newCheckedStatus);
  };
  const checkedStyles = checked ? `${styles.checked}` : '';
  const disabledStyles = isMaximumReached && !checked ? `${styles.disabled}` : '';

  return (
    <label
      className={`${styles.chooseManyCheckbox} ${checkedStyles} ${disabledStyles}`}
      htmlFor={`checkbox-${id}`}
    >
      {label}
      <input
        type="checkbox"
        key={`checkbox-${id}`}
        id={`checkbox-${id}`}
        onChange={handleClickElement}
        checked={checked}
        disabled={isMaximumReached && !checked}
      />
      <span className={styles.chooseManyCheckmark} />
    </label>
  );
};

export default Checkbox;
